// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2fnh1","actionsCol":"EnrolledClinics_actionsCol__1Tq5C"};